import { render, staticRenderFns } from "./authorizedMessage.vue?vue&type=template&id=8f578e1a&scoped=true&"
import script from "./authorizedMessage.vue?vue&type=script&lang=js&"
export * from "./authorizedMessage.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/authorized.css?vue&type=style&index=0&id=8f578e1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f578e1a",
  null
  
)

export default component.exports